/* =========================================================
   innovazone-tracking.js — tracking de clics WhatsApp (evento Contact)
   Publica 'innovazone_contact' al runtime de Customer Events cuando el usuario
   toca cualquier CTA de WhatsApp. El Custom Pixel (analytics/custom-pixel-code.js)
   lo reenvia a Meta como fbq('track','Contact').
   No depende de window.fbq (que no existe en el main world del storefront 2026).
   + REF-WEB (2026-06): marca el origen del anuncio web en el link wa.me.
   + ORIGEN WEB (26-sep): firma «🛒 Vengo de la tienda web» en TODO chat que sale de la tienda.
   ============================================================ */
(function () {
  'use strict';
  var last = 0;

  // REF-WEB: guarda el id del anuncio (utm_content={{ad.id}} o fbclid) de la URL de aterrizaje;
  // sobrevive la navegacion interna hasta que el cliente toca WhatsApp.
  try {
    var _p = new URLSearchParams(location.search);
    var _aid = _p.get('utm_content') || _p.get('fbclid');
    if (_aid) sessionStorage.setItem('iz_ad', _aid);
  } catch (e) {}

  function detectSource(link) {
    if (!link.closest) return 'other';
    if (link.closest('.lp-product-hero, [class*="lp-cod"], [class*="lp-prem"]')) return 'lp-tiktok';
    if (link.closest('header, .header, [class*="header"]')) return 'header';
    if (link.closest('[class*="sticky"], .sticky, [class*="float"]')) return 'sticky';
    if (link.closest('[class*="product"], main')) return 'product-page';
    return 'other';
  }

  function metaContent(sel) {
    var el = document.querySelector(sel);
    return el ? (el.getAttribute('content') || '') : '';
  }

  // ORIGEN WEB (Kevin 26-sep «esas web, que cuenten como web»): TODO chat que sale de la tienda
  // lleva la firma WEB_SIG al final del texto prellenado, venga o no de un anuncio. agent-core la
  // lee en el primer mensaje, etiqueta el lead «web» y kommo-shopify-sync pasa la etiqueta a la orden.
  // Si ademas llego de un anuncio (utm/fbclid) se conserva el marcador viejo [iz-web|adId|pid].
  var WEB_SIG = '\n\n🛒 Vengo de la tienda web';
  function webMarker() {
    var m = WEB_SIG;
    try {
      var aid = sessionStorage.getItem('iz_ad') || '';
      if (aid) {
        var pid = metaContent('meta[property="product:retailer_item_id"]') ||
                  metaContent('meta[property="og:product:retailer_item_id"]') || '';
        m += ' [iz-web|' + aid + '|' + pid + ']';
      }
    } catch (e) {}
    return m;
  }

  function isWa(href) { return /^https?:\/\/(wa\.me|api\.whatsapp\.com|(www\.)?whatsapp\.com)\//i.test(href || ''); }

  // Devuelve la URL de WhatsApp con la firma web agregada al ?text= (una sola vez).
  function withMarker(href) {
    try {
      if (!isWa(href) || href.indexOf('tienda%20web') !== -1 || href.indexOf('tienda+web') !== -1 ||
          decodeURIComponent(href).indexOf('Vengo de la tienda web') !== -1) return href;
      var u = new URL(href, location.origin);
      var txt = (u.searchParams.get('text') || '').trim();
      // Boton sin texto prellenado: el chat abre con un saludo en vez de dos lineas vacias.
      u.searchParams.set('text', txt ? txt + webMarker() : 'Hola, ' + webMarker().replace(/^\s+🛒 V/, 'v') + ' 🛒');
      return u.toString();
    } catch (e) { return href; }
  }

  function addMarkerToLink(link) {
    try {
      var href = link.getAttribute('href') || '';
      var nuevo = withMarker(href);
      if (nuevo !== href) link.setAttribute('href', nuevo);
    } catch (e) {}
  }

  // Los formularios del tema abren WhatsApp con window.open(url) y no con un <a>: se envuelve
  // window.open para que esos chats tambien lleven la firma.
  try {
    var _open = window.open;
    window.open = function (url) {
      var args = Array.prototype.slice.call(arguments);
      try { if (typeof url === 'string' && isWa(url)) args[0] = withMarker(url); } catch (e) {}
      return _open.apply(window, args);
    };
  } catch (e) {}

  function publish(link) {
    var now = Date.now();
    if (now - last < 1500) return;            // dedupe doble-click
    last = now;
    try {
      if (!(window.Shopify && Shopify.analytics &&
            typeof Shopify.analytics.publish === 'function')) return;
      var name = metaContent('meta[property="og:title"]') || document.title || '';
      var pid = metaContent('meta[property="product:retailer_item_id"]') ||
                metaContent('meta[property="og:product:retailer_item_id"]') || '';
      Shopify.analytics.publish('innovazone_contact', {
        content_name: name,
        content_ids: pid ? [String(pid)] : [],
        currency: 'CRC',
        wa_source: detectSource(link)
      });
    } catch (e) { /* silencioso: nunca romper la navegacion al WhatsApp */ }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var a = e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"], a[href*="whatsapp.com/send"], [data-wa-cta]');
    if (a) { addMarkerToLink(a); publish(a); }
  }, true);
})();
